// Messages for operator/TwoFactor (auto-merged by lib/i18n.ts).
export const en = {
  'operator.two_factor.head': 'Two-factor — Operator',
  'operator.two_factor.title': 'Two-factor authentication',
  'operator.two_factor.recovery_intro':
    'Save these recovery codes somewhere safe — each can be used once.',
  'operator.two_factor.on': 'Two-factor authentication is on.',
  'operator.two_factor.turn_off': 'Turn off',
  'operator.two_factor.scan_intro':
    'Scan this QR code with your authenticator app, then enter the 6-digit code to confirm.',
  'operator.two_factor.code_label': 'Verification code',
  'operator.two_factor.code_error': 'Code {error}',
  'operator.two_factor.enable': 'Enable two-factor',
}

export const zhTW = {
  'operator.two_factor.head': '雙重驗證 — 操作端',
  'operator.two_factor.title': '雙重驗證',
  'operator.two_factor.recovery_intro': '請將這些備用碼妥善保存於安全處 — 每組僅能使用一次。',
  'operator.two_factor.on': '雙重驗證已開啟。',
  'operator.two_factor.turn_off': '關閉',
  'operator.two_factor.scan_intro': '使用驗證器應用程式掃描此 QR 碼，然後輸入 6 位數驗證碼以確認。',
  'operator.two_factor.code_label': '驗證碼',
  'operator.two_factor.code_error': '驗證碼{error}',
  'operator.two_factor.enable': '啟用雙重驗證',
}
